import styled from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'

export const InfoHeader = styled.h2<StyledHTMLElement>(() => ({
  fontSize: '16px',
  marginBottom: '12px'
}))
